module.exports = __webpack_public_path__ + "static/img/brand-9.f585c79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-9.svg
// module id = b2iR
// module chunks = 0